import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Card, Button, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2'
import './template.scss';
import { Icon } from '@iconify/react';
import sendOutlined from '@iconify-icons/ant-design/send-outlined';
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import caAPI from "../../../../services/caAPI";
import { AtendimentoContext } from '../../../../contexts/AtendimentoContext';
import { templatesFilter } from '../../../../helpers/TemplateFilter';

export default function Templates({ recebeMensagemInicial }) {
    const [mensagemInicial, setMensagemInicial] = useState();
    const [listaTemplates, setListaTemplates] = useState([]);
    const {atendimentoAtivo} = useContext(AtendimentoContext);
    const { promiseInProgress: promiseBuscaTemplatesAprovadosEmProgresso } = usePromiseTracker({ area: 'busca-templates-aprovados' })

    useEffect(() => {
        trackPromise(
            caAPI.atendimento.whatsapp.templatesAprovadosComOrigem(atendimentoAtivo.origem.id_contato_origem).then(res => {
                setListaTemplates(templatesFilter(res.data, atendimentoAtivo));
            }).catch(err => {
                Swal.fire({
                    titleText: "Erro",
                    text: "Houve um problema ao buscar ao buscar os templates de mensagens " + err,
                    icon: 'error'
                });
                return;
            }),
            'busca-templates-aprovados'
        )
    }, []);


    function selecionaMensagem(idTemplateSelecionado) {
        const mensagem = listaTemplates.find(template => template.id.toString() === idTemplateSelecionado).mensagem;
        setMensagemInicial({
            id_template: idTemplateSelecionado,
            mensagem : mensagem.replace(/<\/?[^>]+(>|$)/g, "")
        })
    }


    return promiseBuscaTemplatesAprovadosEmProgresso && <div className="d-flex justify-content-center align-items-center py-3">
        <Spinner animation="border" style={{ color: "#265d9c" }} className="mr-2" /> <span>Carregando templates...</span>
    </div> || <>
        <div className="templatesContainer">
        <div className="cabecalhoTemplates">
            <div className="tituloTemplares">Selecione um modelo de mensagem para iniciar o atendimento</div>
            <div className="infoTemplates">Lembrando que só será possível conversar com o cliente após obter a resposta a essa mensagem.</div>
            <p />
            <div className="selecioneTemplares">Click sobre a mensagem para selecionar:</div>
        </div>
        <div className="selecaoTemplates">
            <Form>
                <Form.Group >
                    <Form.Control
                        as="radio"
                        custom
                        onChange={(event) => selecionaMensagem(event.target.id)}
                    >
                        {listaTemplates && listaTemplates.map((template) =>
                            <div key={template.id}>
                                <Row>
                                    <Card className="templateCard">
                                        <Card.Body className="templateCorpo">
                                            <Form.Check
                                                className="template"
                                                type="radio"
                                                id={template.id}
                                                value={template.id}
                                            >
                                                <Form.Check.Input type='radio' name="selecionatemplate" isValid />
                                                <Form.Label><strong style={{ fontSize: '1rem' }}>{template.nome}</strong></Form.Label>
                                                <Form.Label >
                                                    <div >
                                                        {template.mensagem.replace(/<\/?[^>]+(>|$)/g, "")}
                                                    </div>
                                                </Form.Label>
                                            </Form.Check>
                                        </Card.Body>
                                    </Card>
                                </Row>
                            </div>
                        )}
                        <Button className="btnEnviaPrimeiraMensagem" onClick={() => {
                            mensagemInicial ? recebeMensagemInicial(mensagemInicial, true)
                                :
                                Swal.fire({
                                    titleText: "Atenção",
                                    text: "Selecione uma mensagem para enviar",
                                    icon: 'warning'
                                });
                        }}>
                            Enviar mensagem selecionada <Icon icon={sendOutlined} color="white" />
                        </Button>

                    </Form.Control>
                </Form.Group>
            </Form>
        </div>
    </div>
    </>;
}
